import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

/**
 * MontageListItemAPI - API controller for montage list items
 */
export default class MontageListItemAPI {
    public static async getByMontageListId(montageListId: string): Promise<AxiosResponse> {
        try {
            const response = await ApiController.get(ApiRoutes.montageListItems.getByMontageListId(montageListId));
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async getById(id: string): Promise<AxiosResponse> {
        try {
            const response = await ApiController.get(ApiRoutes.montageListItems.getById(id));
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async create(montageListId: string, itemData: any): Promise<AxiosResponse> {
        const request = {
            data: {
                type: 'montage_list_items',
                attributes: {
                    ...itemData,
                },
                relationships: {
                    montageList: {
                        data: {
                            type: 'montage_lists',
                            id: montageListId,
                        },
                    },
                },
            },
        };

        try {
            const response = await ApiController.post(ApiRoutes.montageListItems.create, request);
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async update(id: string, itemData: any): Promise<AxiosResponse> {
        const request = {
            data: {
                type: 'montage_list_items',
                id,
                attributes: {
                    ...itemData,
                },
            },
        };

        try {
            const response = await ApiController.patch(ApiRoutes.montageListItems.update(id), request);
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async delete(id: string): Promise<AxiosResponse> {
        try {
            const response = await ApiController.delete(ApiRoutes.montageListItems.delete(id));
            return response as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
    }
}
